module.exports = __webpack_public_path__ + "img/qrcode.85ee7048.jpg";